import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  const hint = typeof window !== 'undefined' && window.location?.hostname !== 'localhost'
    ? ' On Vercel/production: set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in Project Settings → Environment Variables, then redeploy.'
    : ' Check your .env file.';
  throw new Error('Missing Supabase environment variables.' + hint);
}
if (!supabaseUrl.includes('supabase.co')) {
  console.warn('Supabase URL may be incorrect (expected *supabase.co). On Vercel, set REACT_APP_SUPABASE_URL and redeploy.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'rhwb-coach-portal-auth', // App-specific storage key
    storage: {
      getItem: (key) => {
        try {
          return localStorage.getItem(`rhwb-coach-portal-${key}`);
        } catch {
          return null;
        }
      },
      setItem: (key, value) => {
        try {
          localStorage.setItem(`rhwb-coach-portal-${key}`, value);
        } catch {
          // Handle storage errors
        }
      },
      removeItem: (key) => {
        try {
          localStorage.removeItem(`rhwb-coach-portal-${key}`);
        } catch {
          // Handle storage errors
        }
      }
    }
  }
}); 